defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/Modals/DeleteClubModal',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, PlayTogetherApi, CtaButton) {
    var DeleteClubModal = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.processingClubDeletion = m.prop(false);
        this.dictionary = this.rootDictionary.get.bind({ prefix: 'ClubSettings/DeleteClubOverlay/' });

        this.confirm = () => {
          this.processingClubDeletion(true);
          PlayTogetherApi.deleteClub(this.clubId())
            .then(() => {
              window.location = this.navigationPaths.myClubsPage;
            })
            .catch((error) => {
              this.processingClubDeletion(false);
              this.error(error);
              this.modal.close();
            });
        };
      },
      view: function (controller, { template }) {
        const footer = [
          CtaButton({
            text: controller.dictionary('Dismiss'),
            onClick: () => controller.modal.close()
          }),
          CtaButton({
            text: controller.dictionary('Confirm'),
            onClick: controller.confirm,
            className: 'yellow',
            loading: controller.processingClubDeletion()
          })
        ];

        return template({
          heading: m.trust(controller.dictionary('Title', { clubName: controller.clubName()() })),
          body: m.trust(controller.dictionary('Description', { clubName: controller.clubName()() })),
          footer
        });
      }
    };

    // Public functions:
    return DeleteClubModal;
  });
